export const getError = (error) => {
  switch (error) {
  case "passwordLength":
    return "Must contain at least 8 characters";

  case "passwordEmpty":
    return "This field must be completed";

  case "invalidFormat":
    return "Please, enter a valid email format";

  default:
    return "Unexpected Error";
  }
};
